import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import * as api from '../api';
import { toast } from 'react-toastify';

//액션 타입
const GET_CUSTOMER_LIST = 'GET_CUSTOMER_LIST';
const GET_CUSTOMER_DETAIL = 'GET_CUSTOMER_DETAIL';
const DELETE_CUSTOMER = 'DELETE_CUSTOMER';
const CREATE_CUSTOMER = 'CREATE_CUSTOMER';
const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER';
const INITIALIZE_CUSTOMER_STATE = 'INITIALIZE_CUSTOMER_STATE';
//액션 생성자
export const GetCustomerList = createAction(GET_CUSTOMER_LIST, api.getCustomerList);
export const GetCustomerDetail = createAction(GET_CUSTOMER_DETAIL, api.getDetailCustomer);
export const CreateCustomer = createAction(CREATE_CUSTOMER, api.createCustomer);
export const UpdateCustomer = createAction(UPDATE_CUSTOMER, api.updateCustomer);
export const DeleteCustomer = createAction(DELETE_CUSTOMER, api.deleteCustomer);
export const initializeCustomerState = createAction(INITIALIZE_CUSTOMER_STATE, sliceStoreName => sliceStoreName)
export const defalutCustomerState = {
    listData: [],
    detailData: {},
    address: {},
    status: 'PENDING',
    nowPage: 0
}

export default handleActions({
[ initializeCustomerState().type ]: (state, { payload: { sliceStoreName, defaultState } }) => {
    return Object.assign({},state,{
        [sliceStoreName]: defaultState
    })
},
...pender({
    type: GET_CUSTOMER_LIST,
    onPending: (state) => {
        return Object.assign({},state,{
            status : 'PENDING'
        })
    },
    onSuccess: (state, action) => {
        const { data } = action.payload;
        if (data){
          return Object.assign({},state,{
            status:'DONE',
            listData : data
          })
        } else {
          return Object.assign({},state,{
            status:'DONE',
            listData : []
          })
        }
    },
}),
...pender({
    type: GET_CUSTOMER_DETAIL,
    onPending: (state) => {
        return Object.assign({},state,{
            status : 'PENDING'
        })
    },
    onSuccess: (state, action) => {
        const { data } = action.payload;
        if (data){
          return Object.assign({},state,{
            status:'DETAIL',
            detailData : {...data,gender: {value: data.gender, label: data.gender}, insurance: JSON.parse(data.insurance)},
          })
        } else {
          return Object.assign({},state,{
            detailData : {}
          })
        }
    },
}),
...pender({
    type: CREATE_CUSTOMER,
    onPending: (state) => {
        return Object.assign({},state,{
            status : 'PENDING'
        })
    },
    onSuccess: (state, action) => {
      const { data } = action.payload;
      if (data && data.errorCode === 910202) {
        toast.error('최대 1000명까지만 업로드 가능합니다.');
        return Object.assign({},state,{
          status : 'DONE'
        })
      } else {
        toast.success('등록 완료');
        return Object.assign({},state,{
          status : 'CREATED',
          detailData : {...data,insurance: JSON.parse(data.insurance)},
        })
      }
    },
    onFailure:  (state, action) => {
      toast.error('등록 실패');
        const { data } = action.payload;
        if (data){
          return Object.assign({},state,{
            status : 'DONE'
          })
        }
    }
}),
...pender({
    type: UPDATE_CUSTOMER,
    onPending: (state) => {
        return Object.assign({},state,{
            status : 'PENDING'
        })
    },
    onSuccess: (state, action) => {
      toast.success('수정 완료');
      const { data } = action.payload;
        if (data){
          return Object.assign({},state,{
            status : 'UPDATED'
          })
        }
    },
    onFailure:  (state, action) => {
      toast.error('수정 실패');
        const { data } = action.payload;
        if (data){
          return Object.assign({},state,{
            status : 'DONE'
          })
        }
    }
}),
...pender({
    type: DELETE_CUSTOMER,
    onPending: (state) => {
        return Object.assign({},state,{
            status : 'PENDING'
        })
    },
    onSuccess: (state, action) => {
      toast.success('삭제 완료');
        const { data } = action.payload;
        if (data){
          return Object.assign({},state,{
            status : 'DELETED'
          })
        }
    },
    onFailure:  (state, action) => {
      toast.error('삭제 실패');
        const { data } = action.payload;
        if (data){
          return Object.assign({},state,{
            status : 'DONE'
          })
        }
    }
}),
}, defalutCustomerState);
